import { useState, useCallback } from 'react';
import { Pattern } from '../types';

const PATTERNS: Pattern[] = [
  {
    sequence: [0.25, 0.5, 1, 2, '?'],
    answer: 4,
    type: 'decimal',
    hint: 'Each number is doubled',
    points: 10
  },
  {
    sequence: [1/4, 1/2, 3/4, '?'],
    answer: 1,
    type: 'fraction',
    hint: 'Add 1/4 each time',
    points: 15
  },
  {
    sequence: [0.1, 0.3, 0.9, '?'],
    answer: 2.7,
    type: 'decimal',
    hint: 'Multiply by 3 each time',
    points: 20
  },
  {
    sequence: [2.5, 2, 1.5, '?'],
    answer: 1,
    type: 'decimal',
    hint: 'Subtract 0.5 each time',
    points: 15
  }
];

export const useAlgebraGame = () => {
  const [currentLevel, setCurrentLevel] = useState(0);
  const [score, setScore] = useState(0);
  const [attempts, setAttempts] = useState(0);
  const [maxAttempts] = useState(3);
  const [gameOver, setGameOver] = useState(false);
  const [showHint, setShowHint] = useState(false);

  const getCurrentPattern = useCallback(() => {
    return PATTERNS[currentLevel];
  }, [currentLevel]);

  const checkAnswer = useCallback((answer: number) => {
    const pattern = getCurrentPattern();
    const isCorrect = Math.abs(answer - pattern.answer) < 0.001;

    if (isCorrect) {
      const bonusPoints = (maxAttempts - attempts) * 5;
      const totalPoints = pattern.points + bonusPoints;
      setScore(prev => prev + totalPoints);
      
      if (currentLevel === PATTERNS.length - 1) {
        setGameOver(true);
      } else {
        setCurrentLevel(prev => prev + 1);
        setAttempts(0);
        setShowHint(false);
      }
      return true;
    } else {
      setAttempts(prev => {
        const newAttempts = prev + 1;
        if (newAttempts >= maxAttempts) {
          setGameOver(true);
        }
        return newAttempts;
      });
      return false;
    }
  }, [currentLevel, attempts, maxAttempts]);

  const toggleHint = useCallback(() => {
    setShowHint(prev => !prev);
  }, []);

  return {
    pattern: getCurrentPattern(),
    score,
    attempts,
    maxAttempts,
    gameOver,
    showHint,
    checkAnswer,
    toggleHint
  };
};